function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M87.1,239.66Q82.57,247,72.47,250.11q10.09,3.13,14.63,10.45t4.52,21.59v76.26q0,27.16,25.77,27.16h8.71v27.51H110.78q-26.13,0-39.35-13.06T58.19,361.55v-80.1Q58.19,264,42.52,264H30.33V236.18H42.52q15.67,0,15.67-17.41v-80.1q0-25.41,13.24-38.48t39.35-13.06H126.1v27.52h-8.71q-25.77,0-25.77,27.16v76.26Q91.62,232.35,87.1,239.66Z",
  transform: "translate(-30.33 -87.13)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M471.33,236.18V264H459.49q-15.33,0-15.32,17.41v80.1q0,25.41-13.41,38.47t-39.52,13.06H375.92V385.57h8.35q26.46,0,26.47-27.16V282.15q0-14.62,4.35-21.77t14.45-10.27q-10.1-3.13-14.45-10.27t-4.35-21.77V141.81q0-27.16-26.47-27.16h-8.35V87.13h15.32q26.11,0,39.52,13.06t13.41,38.48v80.1q0,17.41,15.32,17.41Z",
  transform: "translate(-30.33 -87.13)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M228.92,201.24a22.08,22.08,0,0,1,6-15.5,20,20,0,0,1,15.33-6.5,22,22,0,0,1,16.17,6.5,21.18,21.18,0,0,1,6.5,15.5,19.21,19.21,0,0,1-6.5,14.67,22.92,22.92,0,0,1-16.17,6q-9.33,0-15.33-6A20,20,0,0,1,228.92,201.24Z",
  transform: "translate(-30.33 -87.13)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M228.92,301.11a22.08,22.08,0,0,1,6-15.5,20,20,0,0,1,15.33-6.5,22,22,0,0,1,16.17,6.5,21.18,21.18,0,0,1,6.5,15.5,19.21,19.21,0,0,1-6.5,14.67,22.92,22.92,0,0,1-16.17,6q-9.33,0-15.33-6A20,20,0,0,1,228.92,301.11Z",
  transform: "translate(-30.33 -87.13)"
});

var SvgDopsFaviconBlack = function SvgDopsFaviconBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 441 325.95",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDopsFaviconBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dops_favicon_black.0c0a9450.svg";
export { ForwardRef as ReactComponent };